export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    loading: boolean
    content: string
    renderedContent: string
    streaming: boolean
    typing: boolean
    completeCount: number
}

const fullText = 'Bubble 会在流式内容持续更新时，保持打字动画和完成回调之间的边界稳定。';

export default class extends Component<Props> {
    static template = template;

    private timer: number | null = null;
    private loadingTimer: number | null = null;

    static defaults() {
        return {
            loading: true,
            content: '',
            renderedContent: '',
            streaming: false,
            typing: true,
            completeCount: 0,
        };
    }

    start(typing: boolean, step: number, interval: number) {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this.loadingTimer) {
            clearTimeout(this.loadingTimer);
            this.loadingTimer = null;
        }

        this.set({
            loading: true,
            content: '',
            renderedContent: '',
            streaming: false,
            typing,
            completeCount: 0,
        });

        this.loadingTimer = window.setTimeout(() => {
            this.loadingTimer = null;
            this.set({
                loading: false,
                streaming: true,
            });

            this.timer = window.setInterval(() => {
                const nextValue = fullText.slice(0, this.get('content').length + step);
                this.set('content', nextValue);

                if (nextValue.length >= fullText.length) {
                    clearInterval(this.timer!);
                    this.timer = null;
                    this.set('streaming', false);
                }
            }, interval);
        }, 800);
    }

    @bind
    startSlowTyping() {
        this.start(true, 2, 120);
    }

    @bind
    startFastTyping() {
        this.start(true, 8, 40);
    }

    @bind
    startStreamingOnly() {
        this.start(false, 4, 80);
        this.set('renderedContent', '未开启typing属性，不会触发`typing`事件');
    }

    @bind
    onTyping(renderedContent: string) {
        this.set('renderedContent', renderedContent);
    }

    @bind
    onTypingComplete() {
        this.set('completeCount', this.get('completeCount') + 1);
    }

    getTypingOptions() {
        return this.get('typing') ? {interval: 24, step: 2} : false;
    }
}